import $ from 'jquery';

/**
 * Portlet Widget
 */
export default class Portlet {
	constructor() {
		this.$body = $('body');
		this.$portletIdentifier = '.card';
		this.$portletCloser = '.card a[data-bs-toggle="remove"]';
		this.$portletRefresher = '.card a[data-bs-toggle="reload"]';
	}

	init() {
		var $this = this;
		$(document).on('click', this.$portletCloser, function(ev) {
			ev.preventDefault();
			var $portlet = $(this).closest($this.$portletIdentifier);
			var $portlet_parent = $portlet.parent();
			$portlet.remove();
			if ($portlet_parent.children().length == 0) {
				$portlet_parent.remove();
			}
		});

		// Panel Reload
		$(document).on('click', this.$portletRefresher, function(ev) {
			ev.preventDefault();
			var $portlet = $(this).closest($this.$portletIdentifier);
			// This is just a simulation, nothing is going to be reloaded
			$portlet.append('<div class="card-disabled"><div class="card-portlets-loader"></div></div>');
			var $pd = $portlet.find('.card-disabled');
			setTimeout(function() {
				$pd.fadeOut('fast', function() {
					$pd.remove();
				});
			}, 500 + 300 * (Math.random() * 5));
		});
	}
}
